// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Float from "bs-platform/lib/es6/belt_Float.js";

var name = "coordinate";

function render(c) {
  var s = "(" + (c.coordinate_id + (") x=" + (String(c.x) + (" y=" + String(c.y)))));
  return React.createElement("div", {
              key: c.coordinate_id
            }, s);
}

var Coordinate = {
  name: name,
  render: render
};

function Coordinate$Add(Props) {
  var updater = Props.updater;
  var match = React.useState(function () {
        return {
                name: "",
                x: "0",
                y: "0"
              };
      });
  var setState = match[1];
  var state = match[0];
  var handleName = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: a,
                          x: st.x,
                          y: st.y
                        };
                }));
  };
  var handleX = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: st.name,
                          x: a,
                          y: st.y
                        };
                }));
  };
  var handleY = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: st.name,
                          x: st.x,
                          y: a
                        };
                }));
  };
  var handleSubmit = function (e) {
    e.preventDefault();
    var match = Belt_Float.fromString(state.x);
    var match$1 = Belt_Float.fromString(state.y);
    if (match !== undefined && match$1 !== undefined) {
      Curry._3(updater, state.name, match, match$1);
      return Curry._1(setState, (function (param) {
                    return {
                            name: "",
                            x: "",
                            y: ""
                          };
                  }));
    }
    
  };
  return React.createElement("div", {
              className: "add coordinate"
            }, React.createElement("form", {
                  onSubmit: handleSubmit
                }, "Coordinate: ", "name=", React.createElement("input", {
                      className: "input-name",
                      name: "name",
                      type: "text",
                      value: state.name,
                      onChange: handleName
                    }), ", x=", React.createElement("input", {
                      className: "input-num",
                      name: "x",
                      type: "text",
                      value: state.x,
                      onChange: handleX
                    }), ", y=", React.createElement("input", {
                      className: "input-num",
                      name: "y",
                      type: "text",
                      value: state.y,
                      onChange: handleY
                    }), React.createElement("input", {
                      type: "submit",
                      value: "add/modify",
                      onClick: (function (param) {
                          
                        })
                    })));
}

var Add = {
  make: Coordinate$Add
};

var testa = {
  coordinate_id: "a",
  x: 1,
  y: 2
};

var testb = {
  coordinate_id: "b",
  x: 3,
  y: 4
};

export {
  Coordinate ,
  testa ,
  testb ,
  name ,
  render ,
  Add ,
  
}
/* react Not a pure module */
